export default __webpack_public_path__ + "static/media/exit-orange.903e2818.svg";